import type { Optional } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import dayjs from 'dayjs'

import { useConfigurationContext } from '../../context/configurationContext'
import { useTemplateContext } from '../../context/templateContext'
import { templateIdFromPath } from '../../uiModels/templateOperations/helpers'
import type { FieldOrigin } from '../../uiModels/types'
import { useTemplateVersionInfo } from '../../uiModels/versionInfo/useTemplateVersionInfo'
import { useCompareContext } from './valueSetupCompareContext'

type Props = {
  origin: Optional<FieldOrigin>
  variant: 'current' | 'compare'
}

export const DiffHeader = ({ origin, variant }: Props) => {
  const translate = useTranslate()
  const { previousTemplateVersion } = useTemplateContext()
  const { compareType } = useCompareContext()
  const { viewAt } = useConfigurationContext()
  const templateId = origin ? templateIdFromPath(origin) : null
  const originTemplateVersionInfo = useTemplateVersionInfo({
    id: templateId,
    date: viewAt,
  })

  const diffedOperationVersionInfo =
    compareType === 'inherited' || variant === 'current'
      ? originTemplateVersionInfo
      : previousTemplateVersion?.versionInfo

  if (!diffedOperationVersionInfo || !templateId) {
    return <div>{translate('diffPopover.empty')}</div>
  }

  const diffedOperationFromDate = diffedOperationVersionInfo.fromDate
    ? dayjs(diffedOperationVersionInfo.fromDate).format('L')
    : '-'

  return (
    <div className="flex flex-row items-center justify-between font-medium">
      {templateId} {diffedOperationFromDate}
    </div>
  )
}
